package top.wcpe.allincore.dsl.ir.model.action

/**
 * action 体 IR。
 *
 * `bodyBytes` 为 codegen 阶段把 action 体语句序列化后的字节流；M4 不解码，M5 interp 消费。
 * 构造时与 getter 均做拷贝，避免外部数组篡改内部状态。
 *
 * M10 引入 [Kind]：默认 [Kind.BLOCK] 表示常规语句体；[Kind.STATE_TRANSITION]
 * 表示 `fsm.go("X")` 类动作，`bodyBytes` 内载荷由运行时解析为状态机切换参数。
 * 老 v7 .uir 解码时统一视作 [Kind.BLOCK]。
 */
class UiAction(
    // val 属性生成 getName() / getKind()，与原 Java getter 名一致。
    val name: String,
    val kind: Kind,
    // 防御式拷贝：构造入参数组，避免外部数组篡改内部字节。
    bodyBytes: ByteArray,
) {

    /** action 类别。Wire format 中通过 u8 编码（v8+）。 */
    enum class Kind {
        /** 常规语句体（v7 唯一形态）。 */
        BLOCK,

        /** 状态机切换：`fsm.go("target")`。bodyBytes 由 runtime 自定义编码。 */
        STATE_TRANSITION
    }

    private val bodyBytesInternal: ByteArray = bodyBytes.copyOf()

    /** 兼容旧调用点：默认以 [Kind.BLOCK] 构造。 */
    constructor(name: String, bodyBytes: ByteArray) : this(name, Kind.BLOCK, bodyBytes)

    /** 返回 bodyBytes 的副本（避免外部篡改内部状态）。属性形态使 Java 侧仍以 getBodyBytes() 访问。 */
    val bodyBytes: ByteArray
        get() = bodyBytesInternal.copyOf()

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiAction) return false
        return name == other.name &&
            kind == other.kind &&
            bodyBytesInternal.contentEquals(other.bodyBytesInternal)
    }

    // 逐位复刻：31 * (31 * name.hashCode() + kind.hashCode()) + Arrays.hashCode(bodyBytes)。
    override fun hashCode(): Int =
        31 * (31 * name.hashCode() + kind.hashCode()) + bodyBytesInternal.contentHashCode()

    override fun toString(): String =
        "UiAction{" + name + "," + kind + ",len=" + bodyBytesInternal.size + "}"
}
